var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHandshake = function SvgHandshake(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6004 34.2C22.7004 35.3 22.7004 37 21.6004 38.1L19.0004 40.7C17.9004 41.8 16.2004 41.8 15.1004 40.7C14.0004 39.6 14.0004 37.9 15.1004 36.8L17.7004 34.2C18.8004 33.1 20.5004 33.1 21.6004 34.2Z",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6004 37.0001C27.7004 38.1001 27.7004 39.8001 26.6004 40.9001L23.0004 44.4001C21.9004 45.5001 20.2004 45.5001 19.1004 44.4001C18.0004 43.3001 18.0004 41.6001 19.1004 40.5001L22.7004 36.9001C23.8004 35.9001 25.5004 35.9001 26.6004 37.0001Z",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1004 40.2C32.2004 41.3 32.2004 42.9999 31.1004 44.0999L27.5004 47.7C26.4004 48.8 24.7004 48.8 23.6004 47.7C22.5004 46.6 22.5004 44.8999 23.6004 43.7999L27.2004 40.2C28.3004 39.2 30.0004 39.2 31.1004 40.2Z",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9004 19.7C24.2004 19 27.2004 19.4 29.2004 20.1C29.5004 20.2 29.8004 20.3 30.0004 20.4",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 34.5L15.0002 36.7",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3996 34.1L44.4996 37.8C45.6996 38.7 47.4996 38.4 48.2996 37.2C49.1996 36 48.8996 34.3 47.6996 33.4L43.6996 30.4L37.0996 25.5C37.0996 25.5 35.7996 24.2 33.4996 25.5C31.1996 26.8 26.2996 29.6 26.2996 29.6C26.2996 29.6 23.2996 31.3 21.6996 28.6C20.0996 25.9 23.3996 24 23.3996 24L30.4996 20C30.4996 20 33.2996 18.5 35.9996 18.4C40.1996 18.2 41.4996 19.2 42.6996 18.7C43.8996 18.1 47.2996 15.7 48.7996 14.6C49.2996 14.3 49.8996 14.4 50.1996 14.9L57.7996 27.8C58.0996 28.3 57.9996 28.9 57.4996 29.2L48.9996 34.7",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37.6L41.4 42.2C42.6 43.1 44.3 42.8 45.2 41.6C46.1 40.4 45.8 38.7 44.6 37.8L38.7 33.6",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7002 45.6L37.5002 46.2C38.7002 47.1 40.4002 46.8 41.3002 45.6C42.2002 44.4 41.9002 42.7 40.7002 41.8C39.2002 40.7 37.9002 39.8 36.1002 38.5L35.2002 37.9",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 30C10.2941 30 11.1 29.1941 11.1 28.2C11.1 27.2059 10.2941 26.4 9.3 26.4C8.30589 26.4 7.5 27.2059 7.5 28.2C7.5 29.1941 8.30589 30 9.3 30Z",
    className: "highlight",
    strokeWidth: 1.8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6002 43.6C36.7002 44.7 36.7002 46.4 35.6002 47.5L34.3002 48.8C33.2002 49.9 31.5002 49.9 30.4002 48.8C29.3002 47.7 29.3002 46 30.4002 44.9L31.7002 43.6C32.8002 42.5 34.5002 42.5 35.6002 43.6Z",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2998 29.7L11.8998 14C11.8998 14 11.9998 13.9 11.9998 14L19.9998 18.9C20.4998 19.2 20.6998 19.9 20.3998 20.4L11.8998 34.4C11.5998 34.9 10.8998 35.1 10.3998 34.8L2.3998 29.9C2.2998 29.8 2.2998 29.7 2.2998 29.7Z",
    stroke: "currentColor",
    strokeWidth: 1.8
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHandshake);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/svg-icons/handshake.svg";